/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ShopCouponDetailPage = lazyLoad(
  () => import('./index'),
  module => module.ShopCouponDetailPage
);
